import request from '@/utils/request'
// 获取qrcode列表
export function spWorkWechatSpCorpUserQrcode(params) {
  return request({
    url: '/spWorkWechat/spCorp/userQrcode',
    method: 'get',
    params
  })
}
// qrcode创建
export function spWorkWechatSpCorpUserQrcodeCreate(data) {
  return request({
    url: '/spWorkWechat/spCorp/userQrcodeCreate',
    method: 'post',
    data
  })
}
